<div class="editor-wrapper">
   <mat-label *ngIf="formCtrl.value" class="editor-label">
      {{ label }}
   </mat-label>
   <div class="editor" (click)="focusEditor()">
      <textarea
         matInput
         type="text"
         [formControl]="formCtrl"
         [froalaEditor]="editorConfig"
         (froalaInit)="initFroala($event)"
      ></textarea>
   </div>
</div>
